import prjAttr from 'prjAttr';
import EFOcats_import_lang from '../../core/v2/import/efocats_import_lang.js';
import EFOcats_import_html from '../../core/v2/import/efocats_import_html.js';
import EFOcats_import_style from '../../core/v2/import/efocats_import_style.js';
import EFOcats_settingdata from '../../core/v2/setting/efocats_settingdata.js';
import EFOcats_making from '../../core/v2/making/efocats_making.js';
import EFOcats_submit from '../../core/v2/submit/efocats_submit.js';
import EFOcats_Validates from '../../core/v2/validate/efocats_validates.js';
import EFOcats_event from '../../core/v2/event/efocats_event.js';

/**
 * EFOcatsコアクラス
 */
export default class EFOcats {
  /**
   * コンストラクタ
   */
  constructor() {
    // coreのenvディレクトリ以下を配列に読み込む
    try {
      const context = require.context(`../../env`);
      this.proj = {};
      context.keys().forEach(path => {
        const name = path.match(/([^/]*)(?:\.([^.]+$))/)[1];

        if (name !== '') {
          this.proj[name] = context(path);
        }

        // import系クラスで使用するファイルをロードする
        this.loadImportFiles(name);
      });
    } catch {
      //
    }

    // 案件のenvディレクトリ以下を配列に読み込む
    try {
      const contextPrj = require.context(`../../project/${prjname}/env`);
      contextPrj.keys().forEach(path => {
        const name = path.match(/([^/]*)(?:\.([^.]+$))/)[1];

        if (name !== '') {
          if (name === 'env' && this.proj[name]) {
            // マージ
            const cloneObj = {...this.proj[name]};
            const mergeObj = Object.assign(cloneObj.default, contextPrj(path).default);
            this.proj[name] = mergeObj;
          } else {
            this.proj[name] = contextPrj(path);
          }

          // import系クラスで使用するファイルをロードする
          this.loadImportFiles(name);
        }
      });
    } catch {
      //
    }

    // 処理クラスのインスタンスを生成する(案件でサブクラスがある場合はそれを優先する)
    this.createSubClass(EFOcats_settingdata, 'settingdata', `setting/efocats_${prjname}_settingdata.js`);
    this.createSubClass(EFOcats_submit, 'submit', `submit/efocats_${prjname}_submit.js`);
    this.createSubClass(EFOcats_Validates, 'validations', `validate/efocats_${prjname}_validates.js`);
    this.createSubClass(EFOcats_event, 'events', `event/efocats_${prjname}_event.js`);
    this.createSubClass(EFOcats_making, 'making', `making/efocats_${prjname}_making.js`);

    // 属性自動取り込み対象追加
    this.settingdata.importAttrs.concat(this.proj.env.importAttrs);

    // 設定値
    this.rollbackTime = this.proj.env.rollbackTime;
    this.AndoroidVer = this.proj.env.AndoroidVer;
    this.iOSVer = this.proj.env.iOSVer;

    // フレーム設置先
    this.targetQurey = this.proj.env.targetQurey;

    // 元フォームを取得するためのクエリ
    this.formQuery = this.proj.env.formQuery;

    // フォーム内のページ区切り
    this.settingdata.pageQuery = this.proj.env.pageQuery;

    // ページから中設問を取得するクエリ
    this.settingdata.questionQuery = this.proj.env.questionQuery;

    // 送信ボタンのセレクタ
    this.submit.submitbtn_query = this.proj.env.submitbtnQuery;

    // 最初のページの戻るボタンの設置
    this.events.page.pager_back = this.proj.env.pager_back;
    this.events.page.pager_back_selector = this.proj.env.pager_back_selector;
    this.events.page.pager_back_url = this.proj.env.pager_back_url;

    // フォームID
    this.account = {
      id: this.proj.env.id,
      form_id: this.proj.env.form_id,
    };

    // 許可デバイス(PC/SP)
    this.AllowDevices = this.proj.env.AllowDevices;

    // パスワード関連
    this.pass = {
      min: this.proj.env.PasswordMinLength,
      max: this.proj.env.PasswordMaxLength,
      limit: this.proj.env.PasswordPattern,
    };

    // 属性リストを読み込み
    this.settingdata.attrjson = prjAttr;

    // モーダルを一度でも開いたかどうか(非モーダルなので最初からtrue)
    this.open_modal = true;

    // 大設問
    this.titleList = this.proj.env.titleList;
    // 大設問下注記
    this.infoList = this.proj.env.infoList;

    // 中設問（name属性:テキスト）
    this.labelList = this.proj.env.labelList;

    // 設問下注記
    this.attentionList = this.proj.env.attentionList;

    // 属性自動読み込み
    this.settingdata.importAttrs = this.settingdata.importAttrs.concat(this.proj.env.importAttrs);
  }

  /**
   * 処理クラスのインスタンスを生成する
   * @param {*} superClass 元のクラス
   * @param {*} propertyName プロパティ名
   * @param {*} subclass 案件で作られるクラス
   */
  createSubClass(superClass, propertyName, subclass) {
    let CreateClass;

    try {
      CreateClass = require(`../../project/${prjname}/${subclass}`).default;
    } catch {
      CreateClass = superClass;
    }

    this[propertyName] = new CreateClass();
  }

  /**
   * import系クラスで使用するファイルをロードする
   * @param {*} name ファイル名
   */
  loadImportFiles(name) {
    if (name === 'exportLang') {
      EFOcats_import_lang.load(this.proj.exportLang);
    } else if (name === 'exportHtml') {
      EFOcats_import_html.load(this.proj.exportHtml);
    } else if (name === 'exportStyle') {
      EFOcats_import_style.load(this.proj.exportStyle);
    }
  }

  /**
   * タグ設置した画面の表示時に呼び出される処理
   * @param id ID
   * @param form_id フォームID
   */
  main() {
    try {
      if (!this.check_environment()) {
        this.making.error();
        return;
      }

      this.making.initialize(this.targetQurey);

      // ロードのタイムアウト
      const loadtimeover = new Promise((resolve, reject) => {
        setTimeout(() => {
          reject(new Error('Load timed over'));
        }, this.rollbackTime);
      });

      Promise.race([this.making.isLoaded(), loadtimeover]).then(
        data => {
          const rollbackTimer = setTimeout(() => this.rollback(), this.rollbackTime);

          this.settingdata
            .load(this.account.id, this.account.form_id)
            .then(loaddata => {
              const editdata = this.settingdata.edit(loaddata, this.formQuery);

              this.making.build(this.account.id, this.account.form_id, editdata);

              this.submit.initialize();

              this.events.initialize();

              this.removeBlind();

              clearTimeout(rollbackTimer);
            })
            .catch((a, b, c) => {
              console.log(a, b, c);
              this.removeBlind();
              this.making.error();
            });
        },
        error => {
          console.log(error);
          this.removeBlind();
          this.making.error();
        }
      );
    } catch (error) {
      this.removeBlind();
      console.log(error);
    }
  }

  /**
   * ロールバック処理
   */
  rollback() {
    this.making.error();

    if (this.intervalList && this.intervalList.length > 0) {
      for (let index = 0; index < this.intervalList.length; index++) {
        clearInterval(this.intervalList[index]);
      }
    }

    this.removeBlind();

    console.log('rollback');
  }

  /**
   * 環境チェック
   */
  check_environment() {
    const ua = window.navigator.userAgent.toLowerCase();

    let device = 'PC';

    if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
      device = 'SP';
    }

    if (efocats.AllowDevices.indexOf(device) < 0) {
      return false;
    }

    if (ua.indexOf('android') !== -1 && ua.indexOf('mobile') !== -1) {
      const version = parseInt(ua.slice(ua.indexOf('android') + 8), 10);

      if (version < this.AndoroidVer) {
        return false;
      }
    } else if (ua.indexOf('iphone os') !== -1) {
      const version = parseInt(ua.slice(ua.indexOf('iphone os') + 10), 10);

      if (version < this.iOSVer) {
        return false;
      }
    }
    return true;
  }

  /**
   * タイマー起動
   * @param {*} func
   * @param {*} delay
   */
  setInterval(func, delay) {
    const id = setInterval(func, delay);

    if (!this.intervalList) this.intervalList = [];

    this.intervalList.push(id);

    return id;
  }

  /**
   * タイマー解除
   * @param {*} id
   */
  clearInterval(id) {
    clearInterval(id);

    const index = this.intervalList.indexOf(id);
    if (index >= 0) {
      this.intervalList.splice(index, 1);
    }
  }

  /**
   * チラ見え対策を解除
   */
  removeBlind() {
    const ellist = document.querySelectorAll('.brind');

    for (let i = 0; i < ellist.length; i++) {
      const el = ellist[i];
      el.parentElement.removeChild(el);
    }
  }
}
